<template>
  <config-pro-plus-base :show-full-comparison-dialog="showFullComparisonDialog" show-plan-details>
    <template #topAlert>
      <CmrPaywallTip :type="cmrPaywallTipType" />
    </template>
    <template #config>
      <config-us :show-full-comparison-dialog="showFullComparisonDialog" :show-explore-c-t-a="true" :show-lm-promo="showIncreaseWithLargeMeetingPromo" />
    </template>
  </config-pro-plus-base>
</template>

<script>
import { planTypes } from '@/common/constants';
import ConfigUs from './config-us';
import ConfigProPlusBase from '@/plans/ZONE_PRO_PLUS/component/config-base';
import ConfigMixin from '@/plans/ZONE_PRO_PLUS/mixin/config-mixin';
import CmrPaywallTip, { CMR_PAYWALL_TIP_TYPES } from '@/components/cmr-paywall-tip.vue'
import { flowTypes } from '@/common/service/page-config';

export default {
  components: { ConfigProPlusBase, ConfigUs, CmrPaywallTip },
  inject: ['$core'],
  mixins: [ConfigMixin],
  data() {
    return {
      cmrPaywallTipType: CMR_PAYWALL_TIP_TYPES.PRO_PLUS,
    }
  },
  computed: {
    fullComparisonDialogProps() {
      return {
        largeMeetingConfig: {
          pro: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: true,
          },
          proPlus: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: false,
          },
          business: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: true,
          },
          businessPlus: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: true,
          },
        }
      }
    },
    showLargeMeetingPromoInComparison() {
      return this.$context.flow === flowTypes.buyNow &&
        (
          this.$core.draftPlanFilterKeys.includes('LARGE_MEETING') ||
          this.$core.addonFilterKeys.includes('LARGE_MEETING')
        )
    },
    showIncreaseWithLargeMeetingPromo() {
      return this.$context.flow === flowTypes.buyNow &&
        !this.$core.draftPlanFilterKeys.includes('LARGE_MEETING') &&
        this.$core.addonFilterKeys.includes('LARGE_MEETING')
    }
  },
  methods: {
    addLargeMeetingCard() {
      this.$core.addon(planTypes[planTypes.LARGE_MEETING]) 
    }
  }
};
</script>
